<template>
  <div class="upload_box">
    <el-upload
      class="avatar-uploader"
      :class="[filestype === 'headImg' ? 'head_img_upload':''
      || filestype === 'filesArticleImg' ? 'background_img_upload':''
      || filestype === 'circleImg' ? 'circle_img_upload':''
      || filestype === 'liveBackground' ? 'background_img_upload':''
      || filestype === 'front' ? 'front_img_upload':''
      || filestype === 'reverse' ? 'reverse_img_upload':''
      || filestype === 'pic' ? 'pic_img_upload':'']"
      v-loading="loading"
      element-loading-text="上传中"
      element-loading-spinner="el-icon-loading"
      action="Fask"
      :show-file-list="false"
      :http-request="UploadImage"
      :before-upload="beforeAvatarUpload"
      :on-change="getFile">
      <img v-if="imageurl"
      :src="imageurl"
      class="avatar"
      :class="[filestype === 'headImg' ? 'head_img':''
      || filestype === 'filesArticleImg' ? 'background_img':''
      || filestype === 'circleImg' ? 'circle_img':''
      || filestype === 'liveBackground' ? 'background_img':''
      || filestype === 'front' ? 'front_img':''
      || filestype === 'reverse' ? 'reverse_img':''
      || filestype === 'pic' ? 'pic_img':'']">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <div slot="tip" class="el-upload__tip">{{imgtext}}</div>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'imgUpload',
  props: {
    filestype: { // 文件类型
      type: String,
      required: true
    },
    imgurl: { // 图片地址
      type: String
    },
    imgtext: { // 图片上传提示文本
      type: String
    }
  },
  data () {
    return {
      imageurl: '',
      list: [],
      uploadOnOff: false,
      loading: false,
      proofImage: ''
    }
  },
  created () {
    this.imageurl = this.imgurl // 获取图片地址
  },
  watch: {
    imgurl (val, oldVal) {
      this.imageurl = val
    }
  },
  methods: {
    // 限制文件类型及大小
    beforeAvatarUpload (file) {
      let fileClass, fileClassErro, fileSize, fileSizeErro
      this.loading = true
      switch (this.filestype) {
        case 'filesArticleImg':
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            fileClass = true
          }
          fileClassErro = '上传内容只能是 JPG/PNG 格式!'
          fileSize = file.size / 1024 / 1024 < 3
          fileSizeErro = '上传图片大小不能超过 3MB!'
          break
        case 'liveBackground':
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            fileClass = true
          }
          fileClassErro = '上传内容只能是 JPG/PNG 格式!'
          fileSize = file.size / 1024 / 1024 < 3
          fileSizeErro = '上传图片大小不能超过 3MB!'
          break
        case 'headImg':
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            fileClass = true
          }
          fileClassErro = '上传内容只能是 JPG/PNG 格式!'
          fileSize = file.size / 1024 / 1024 < 1
          fileSizeErro = '上传头像图片大小不能超过 1MB!'
          break
        case 'circleImg':
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            fileClass = true
          }
          fileClassErro = '上传内容只能是 JPG/PNG 格式!'
          fileSize = file.size / 1024 / 1024 < 1
          fileSizeErro = '上传文件不大于1M'
          break
        case 'front':
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            fileClass = true
          }
          fileClassErro = '上传内容只能是 JPG/PNG 格式!'
          fileSize = file.size / 1024 / 1024 < 2
          fileSizeErro = '上传文件不大于2M'
          break
        case 'reverse':
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            fileClass = true
          }
          fileClassErro = '上传内容只能是 JPG/PNG 格式!'
          fileSize = file.size / 1024 / 1024 < 2
          fileSizeErro = '上传文件不大于2M'
          break
        case 'pic':
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            fileClass = true
          }
          fileClassErro = '上传内容只能是 JPG/PNG 格式!'
          fileSize = file.size / 1024 / 1024 < 2
          fileSizeErro = '上传文件不大于2M'
          break
        default:
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            fileClass = true
          }
          fileClassErro = '上传内容只能是 JPG/PNG 格式!'
          fileSize = file.size / 1024 / 1024 < 3
          fileSizeErro = '上传文件不大于3M'
      }
      if (!fileClass) {
        this.$message.error(fileClassErro)
      }
      if (!fileSize) {
        this.$message.error(fileSizeErro)
      }
      this.uploadOnOff = fileClass && fileSize
    },
    // 图片上传接口
    async UploadImage (param) {
      const vueThat = this
      if (vueThat.uploadOnOff) {
        const formData = new FormData()
        formData.append('image', param.file)
        try {
          await vueThat.myApi.upload(formData)
            .then(function (res) {
              vueThat.loading = false
              if (res.data.code === 200) {
                vueThat.$message({
                  message: '上传成功',
                  type: 'success'
                })
                vueThat.imageurl = res.data.data.url
                vueThat.$emit('files', vueThat.imageurl, vueThat.filestype, vueThat.proofImage)
              }
            })
        } catch (e) {}
      } else {
        vueThat.loading = false
      }
    },
    getFile (file, fileList) {
      this.getBase64(file.raw).then(res => {
        const params = res.split(',')
        if (params.length > 0) {
          this.proofImage = params[1]
        }
      })
    },
    // 获取图片转base64
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
.avatar-uploader-icon{
  width: 200px;
  height: 130px;
  line-height: 130px;
  font-size: 16px;
}
.circle_img_upload .avatar-uploader-icon{
  width: 63px;
  height: 63px;
  line-height: 63px;
  font-size: 16px;
}
.head_img_upload .avatar-uploader-icon{
  width: 88px;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
}
.background_img_upload .avatar-uploader-icon{
  width: 276px;
  height: 177px;
  line-height: 177px;
  font-size: 22px;
}
.front_img_upload .avatar-uploader-icon{
  width: 244px;
  height: 160px;
  background: url(../../assets/img/authentication/front.png) no-repeat;
}
.front_img_upload .avatar-uploader-icon::before{
  content: ''
}
.front_img_upload .avatar-uploader-icon:hover{
  background: url(../../assets/img/authentication/frontHover.png) no-repeat;
}
.reverse_img_upload .avatar-uploader-icon{
  width: 244px;
  height: 160px;
  background: url(../../assets/img/authentication/reverse.png) no-repeat;
}
.reverse_img_upload .avatar-uploader-icon::before{
  content: ''
}
.reverse_img_upload .avatar-uploader-icon:hover{
  background: url(../../assets/img/authentication/reverseHover.png) no-repeat;
}
.pic_img_upload .avatar-uploader-icon{
  width: 80px;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
}
.upload_box .avatar{
  width: 200px;
  height: 130px;
}
.upload_box .avatar.head_img{
  width: 88px;
  height: 100px;
}
.upload_box .avatar.circle_img{
  width: 63px;
  height: 63px;
}
.upload_box .avatar.background_img{
  width: 276px;
  height: 177px;
}
.upload_box .avatar.front_img{
  width: 244px;
  height: 160px;
}
.upload_box .avatar.reverse_img{
  width: 244px;
  height: 160px;
}
.upload_box .avatar.pic_img{
  width: 80px;
  height: 100px;
}
.upload-demo.upload_apply{
  width: 30%;
}

</style>
